module.exports = __webpack_public_path__ + "static/3-47624e15e2c6d2c70060b08c15764708.jpg";